import { Button, notification } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface CopyTextProps {
  text: string;
  children?: ReactNode;
  placement?:
    | 'top'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight';
}

const CopyText = ({
  text,
  children,
  placement = 'topRight',
}: CopyTextProps) => {
  const { t } = useTranslation();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      notification.success({
        message: t('common.copied'),
        description: t('common.copiedDescription'),
        placement,
        duration: 2,
      });
    } catch (err) {
      notification.error({
        message: t('common.copyFailed'),
        description: t('common.tryAgain'),
        placement,
      });
    }
  };

  return (
    <span style={{ display: 'inline-block' }}>
      {children}
      <Button
        type="text"
        icon={<CopyOutlined style={{ fontSize: '14px' }} />}
        onClick={handleCopy}
        title={t('common.copyToClipboard')}
      />
    </span>
  );
};

export default CopyText;
